import {
  ConversationParticipant,
  GetConversationParticipantsParams,
  GetConversationParticipantsResponse,
} from '@stripe-internal/conversations-client';

type GetConversationParticipantsHandlerDeps = {
  getParticipant: () => ConversationParticipant | undefined;
  getAssistantParticipant: () => ConversationParticipant;
};

export class GetConversationParticipantsHandler {
  private deps: GetConversationParticipantsHandlerDeps;

  constructor(deps: GetConversationParticipantsHandlerDeps) {
    this.deps = deps;
  }

  call = async (
    params?: GetConversationParticipantsParams,
  ): Promise<GetConversationParticipantsResponse> => {
    const assistantParticipant = this.deps.getAssistantParticipant();
    const allParticipants: Record<string, ConversationParticipant> = {
      [assistantParticipant.id]: assistantParticipant,
    };
    const currentUserParticipant = this.deps.getParticipant();
    if (currentUserParticipant) {
      allParticipants[currentUserParticipant.id] = currentUserParticipant;
    }

    const participants: Record<string, ConversationParticipant> =
      params?.participantIds
        ? Object.fromEntries(
            params.participantIds
              .filter((id) => id in allParticipants)
              .map((id) => [id, allParticipants[id]]),
          )
        : allParticipants;

    return {code: 200, data: {participants}};
  };
}
